export default class SituacaoCompartilhamentoDados {
    static get EM_PROCESSAMENTO() {
        return 'Em processamento';
    }

    static get FALHA_PROCESSAMENTO() {
        return 'Falha no processamento';
    }

    static get PROCESSADO() {
        return 'Processado';
    }

    static getByName(name) {
        if (!name) return;
        if (name === 'Em processamento') {
            return 'EM_PROCESSAMENTO';
        }
        if (name === 'Falha no processamento') {
            return 'FALHA_PROCESSAMENTO';
        }
        if (name === 'Processado') {
            return 'PROCESSADO';
        }
    }
}
